import * as React from 'react';

import { DetailedSpecifications } from './components/DetailedSpecifications';
import { ISpecificationsDetailed } from '../../types/newbuilding/specificationsDetailed';
import { TitleValueList } from '../TitleValueList';

export function SpecificationsDetailed({
  shortSpecifications,
  shortInfrastructure,
  parking,
  security,
}: ISpecificationsDetailed) {
  return (
    <>
      {shortSpecifications.length > 0 && <TitleValueList items={shortSpecifications} />}
      {shortInfrastructure.length > 0 && (
        <DetailedSpecifications title="Объекты на территории жилого комплекса" items={shortInfrastructure} />
      )}
      {parking.length > 0 && <DetailedSpecifications title="Парковка" items={parking} />}
      {security.length > 0 && <DetailedSpecifications title="Безопасность" items={security} />}
    </>
  );
}
